import { IEmotionCharacterCount } from "motw_core/DTOs/emotioncharactercount";
import * as React from "react";
import { LoadingSpinner } from "source/app/presentation/MainPanel/Calendar/LoadingSpinner";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export function StateProgressChartContainer({
    data,
}: {
    data: IEmotionCharacterCount[] | undefined;
}): JSX.Element {
    if (!data || data.length === 0) {
        return (
            <div style={{ margin: `5px` }}>
                <div
                    className={StyleClassAuto({
                        width: `100%`,
                        textAlign: `center`,
                    })}
                >
                    <LoadingSpinner />
                </div>
            </div>
        );
    }

    return (
        <div>
            <div
                id="stateDominance_container"
                className={StyleClassAuto({
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    margin: "5px",
                    width: `100%`,
                    height: `300px`,
                })}
            ></div>
            <div
                id="stateProgress_container"
                className={StyleClassAuto({
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    margin: "5px",
                    width: `100%`,
                    height: `300px`,
                })}
            ></div>
        </div>
    );
}
